module.exports = __webpack_public_path__ + "static/img/餐补福利-主图@2x.c602956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/餐补福利-主图@2x.png
// module id = +nj3
// module chunks = 1